const AdpActions = {
  SET_USER: 'SET_USER',
  SET_ORGANIZATION: 'SET_ORGANIZATION',
}

export default AdpActions
